<template>
  <!-- changed from slider to input-select, because slider would trigger a save event on every selection -->
  <hm-input-select v-model="internalValue"
                   :label="label"
                   :disabled="disabledCombined"
                   :cols="cols"
                   :name="name">
    <template v-for="it in valueMap">
      <template v-if="it[0] % step === 0 && !hiddenValues.includes(it[0])">
        <option :disabled="it[0] < min || it[0] > max" :key="it[0]" :value="it[0]">{{ it[1] }}</option>
      </template>
    </template>
  </hm-input-select>
<!--  <hm-input-range :min="0"-->
<!--                  :max="24"-->
<!--                  :step="0.25"-->
<!--                  :value-map="valueMap"-->
<!--                  v-model="internalValue"-->
<!--                  :label="label"-->
<!--                  :disabled="disabled"-->
<!--                  :width="width"-->
<!--                  :fa-icon="faIcon"-->
<!--                  :name="name" />-->
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';
import GridMixin from '@/mixins/GridMixin';
import { isNil } from 'lodash';
import HmSelect from './HmSelect.vue';

export default {
  name: 'HmInputTimeOfDaySlider',
  components: { HmSelect },

  mixins: [HmInputMixin, GridMixin],

  props: {
    faIcon: {
      type: String,
      default: 'fal fa-clock',
    },
    min: {
      type: Number,
      default: 0,
      required: false,
    },
    max: {
      type: Number,
      default: 24,
      required: false,
    },
    defaultValue: {
      type: String,
      default: '00:00',
      required: false,
    },
    step: {
      type: Number,
      default: 1,
      required: false,
    },
    suffix: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '25rem',
    },
    convert: {
      type: Boolean,
      default: true,
    },
    hiddenValues: {
      type: Array,
      default: () => ([]),
    },
    valueMap: {
      type: Array,
      default: () => ([
        [0, '00:00'],
        [0.25, '00:15'],
        [0.5, '00:30'],
        [0.75, '00:45'],
        [1, '01:00'],
        [1.25, '01:15'],
        [1.5, '01:30'],
        [1.75, '01:45'],
        [2, '02:00'],
        [2.25, '02:15'],
        [2.5, '02:30'],
        [2.75, '02:45'],
        [3, '03:00'],
        [3.25, '03:15'],
        [3.5, '03:30'],
        [3.75, '03:45'],
        [4, '04:00'],
        [4.25, '04:15'],
        [4.5, '04:30'],
        [4.75, '04:45'],
        [5, '05:00'],
        [5.25, '05:15'],
        [5.5, '05:30'],
        [5.75, '05:45'],
        [6, '06:00'],
        [6.25, '06:15'],
        [6.5, '06:30'],
        [6.75, '06:45'],
        [7, '07:00'],
        [7.25, '07:15'],
        [7.5, '07:30'],
        [7.75, '07:45'],
        [8, '08:00'],
        [8.25, '08:15'],
        [8.5, '08:30'],
        [8.75, '08:45'],
        [9, '09:00'],
        [9.25, '09:15'],
        [9.5, '09:30'],
        [9.75, '09:45'],
        [10, '10:00'],
        [10.25, '10:15'],
        [10.5, '10:30'],
        [10.75, '10:45'],
        [11, '11:00'],
        [11.25, '11:15'],
        [11.5, '11:30'],
        [11.75, '11:45'],
        [12, '12:00'],
        [12.25, '12:15'],
        [12.5, '12:30'],
        [12.75, '12:45'],
        [13, '13:00'],
        [13.25, '13:15'],
        [13.5, '13:30'],
        [13.75, '13:45'],
        [14, '14:00'],
        [14.25, '14:15'],
        [14.5, '14:30'],
        [14.75, '14:45'],
        [15, '15:00'],
        [15.25, '15:15'],
        [15.5, '15:30'],
        [15.75, '15:45'],
        [16, '16:00'],
        [16.25, '16:15'],
        [16.5, '16:30'],
        [16.75, '16:45'],
        [17, '17:00'],
        [17.25, '17:15'],
        [17.5, '17:30'],
        [17.75, '17:45'],
        [18, '18:00'],
        [18.25, '18:15'],
        [18.5, '18:30'],
        [18.75, '18:45'],
        [19, '19:00'],
        [19.25, '19:15'],
        [19.5, '19:30'],
        [19.75, '19:45'],
        [20, '20:00'],
        [20.25, '20:15'],
        [20.5, '20:30'],
        [20.75, '20:45'],
        [21, '21:00'],
        [21.25, '21:15'],
        [21.5, '21:30'],
        [21.75, '21:45'],
        [22, '22:00'],
        [22.25, '22:15'],
        [22.5, '22:30'],
        [22.75, '22:45'],
        [23, '23:00'],
        [23.25, '23:15'],
        [23.5, '23:30'],
        [23.75, '23:45'],
        [24, '24:00'],
      ]),
    },
  },

  computed: {
  },

  methods: {
    convertValueToInternalValue(newVal) {
      if (!this.convert) return newVal;
      try {
        if (isNil(newVal)) {
          return this.convertValueToInternalValue(this.defaultValue);
        } else {
          const timeParts = newVal.split(':');
          return parseInt(timeParts[0], 10) + (parseInt(timeParts[1], 10) / 60);
        }
      } catch (e) {
        return this.convertValueToInternalValue(this.defaultValue);
      }
    },
    convertInternalValueToValue(newVal) {
      if (!this.convert) return newVal;
      try {
        if (isNil(newVal)) {
          return this.defaultValue;
        } else {
          const minutes = ((newVal % 1) * 60);
          const hours = parseInt(newVal, 10);
          return `${hours.toString(10).padStart(2, '0')}:${minutes.toString(10).padStart(2, '0')}`;
        }
      } catch (e) {
        return this.defaultValue;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmInputTimeOfDaySlider.vue